// extracted by mini-css-extract-plugin
module.exports = {"linkLists":"LinkListsLegacyPart_linkLists__lSw9s","column":"LinkListsLegacyPart_column___380F","moreNews":"LinkListsLegacyPart_moreNews__quNhW"};